const pardotForm = document.getElementById('pardot-form');
const pardotInfoForm = document.getElementById('pardot-info');
const VISIBILITY_HIDDEN_CLASS_NAME = 'do-not-show';

class PardotForm {
  constructor(noForm) {
    this.createPardotLinks();

    if(noForm === 'False') {
      this.createForm();

        var whitepaper = document.querySelector('#whitepaper');
        if (!whitepaper) {
            this.initCountDown();
            setInterval(this.initCountDown.bind(this), 60 * 1000);
        }
    }
  }

  createForm() {
    const form = document.querySelector('.pardot-register-form');
    const infoForm = document.querySelector('.pardot-info-form');

    if (form && pardotForm) {
      this.changeDataSrc(form, 'iframe', pardotForm, 'src');
    }
    if (infoForm && pardotInfoForm){
      this.changeDataSrc(infoForm, 'iframe', pardotInfoForm, 'src');
    }
}

  createPardotLinks() {
    const links = document.querySelectorAll('.pardot-left-links');
    const divContainer = document.getElementById('pardot-links');


    if (links && divContainer) {
          links.forEach(el => {
            this.changeDataSrc(el, 'a', divContainer, 'href');
          });
      }
    }


  changeDataSrc(el, tagName, container, attrToSet) {
    const linkTags = el.getElementsByTagName(tagName)
    ;[].slice.call(linkTags).forEach(tag => {
      tag.setAttribute(
        attrToSet,
        tag.getAttribute('data-src').indexOf('CSC_page=') === -1  ? tag.getAttribute('data-src') + '?CSC_page=' + window.location.pathname : tag.getAttribute('data-src')
      );
      container.appendChild(tag);
    });
  }

  addZero(timeUnit) {
    if (timeUnit < 10) {
        return '0' + timeUnit;
    }
    return timeUnit;
  }

  initCountDown() {
      const streamDateTime = Date.parse(
      document.getElementById('streamDate').getAttribute('data-val')
    );

    const streamDateLocal = new Date(streamDateTime);

    // Show local stream time
    const localStreamDateTime = document.getElementById('localStreamTime');

    const dateFormat = {
      month: 'long',
      day: '2-digit',
      year: 'numeric',
    };

    if(localStreamDateTime) {
      localStreamDateTime.innerHTML = `${streamDateLocal.toLocaleString('en-GB', dateFormat)}`;
    }

    const hoursLeft = document.getElementById('hours-left');
    const daysLeft = document.getElementById('days-left');
    const minsLeft = document.getElementById('mins-left');

    const daysCont = document.getElementById('days');
    const minsCont = document.getElementById('minutes');
    const daysSep = document.getElementById('days-separator');
    const minsSep = document.getElementById('min-separator');

    const now = new Date();
    const streamLocalDate = new Date(streamDateLocal);

    if (streamLocalDate.getTime() >= now.getTime()) {
      const diff = new Date(streamLocalDate.getTime() - now.getTime());
      const days =  Math.floor(diff / (1000 * 60 * 60 * 24)); // Gives day count of difference
      const hours = diff.getUTCHours();
      const minutes = diff.getUTCMinutes();

      if (days === 0) {
        daysCont.classList.add(VISIBILITY_HIDDEN_CLASS_NAME);
        minsCont.classList.remove(VISIBILITY_HIDDEN_CLASS_NAME);
        daysSep.classList.add(VISIBILITY_HIDDEN_CLASS_NAME);
        minsSep.classList.remove(VISIBILITY_HIDDEN_CLASS_NAME);
        minsLeft.innerText = this.addZero(minutes);
      }

      daysLeft.innerText = this.addZero(days);
      hoursLeft.innerText = this.addZero(hours);
    } else {

      if (daysLeft && hoursLeft && minsLeft) {
        daysLeft.innerText = 0;
        hoursLeft.innerText = 0;
        minsLeft.innerText = 0;
      }

      const explanatoryTxt = document.getElementById('ongoing-webinar-txt');
      if (explanatoryTxt) {
        explanatoryTxt.classList.remove(VISIBILITY_HIDDEN_CLASS_NAME);
      }
      
      //pardotForm.classList.add(VISIBILITY_HIDDEN_CLASS_NAME);
    }
  }
}

export default PardotForm;
